import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../API/EndPoints";
import AxiosInstance from "../API/AxiosInstance";

// Thunk: Get all doctors
export const getDoctor = createAsyncThunk("master/getAllDoctor", async () => {
  const response = await AxiosInstance.get(API_ENDPOINTS.GET_ALL_DOCTOR);
  return response.data;
});

// Thunk: Get doctors by specialty
export const getDoctorBySpeciality = createAsyncThunk(
  "doctor/getDoctorBySpeciality",
  async (specialityName) => {
    const response = await AxiosInstance.get(
      `${API_ENDPOINTS.GET_DOCTOR_BY_SPECIALITY}`,
      { params: specialityName }
    );
    return response.data;
  }
);

export const getDoctorById = createAsyncThunk(
  "master/getAllDoctorById",
  async (doctorId) => {
    const response = await AxiosInstance.get(
      `${API_ENDPOINTS.DOCTOR_BY_ID}?doctorId=${doctorId}`
    );
    return response.data;
  }
);

// Slice
const doctorSlice = createSlice({
  name: "getDoctor",
  initialState: {
    items: [],
    specialityItems: [],
    loading: false,
    specialityLoading: false,
    error: null,
    specialityError: null,
    doctorById: [],
    doctorByIdLoading: false,
    doctorByIdError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // getDoctor
      .addCase(getDoctor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDoctor.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getDoctor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // getDoctorBySpeciality
      .addCase(getDoctorBySpeciality.pending, (state) => {
        state.specialityLoading = true;
        state.specialityError = null;
      })
      .addCase(getDoctorBySpeciality.fulfilled, (state, action) => {
        state.specialityLoading = false;
        state.specialityItems = action.payload;
      })
      .addCase(getDoctorBySpeciality.rejected, (state, action) => {
        state.specialityLoading = false;
        state.specialityError = action.error.message;
      })

      // getDoctorById
      .addCase(getDoctorById.pending, (state) => {
        state.doctorByIdLoading = true;
        state.doctorByIdError = null;
      })
      .addCase(getDoctorById.fulfilled, (state, action) => {
        state.doctorByIdLoading = false;
        state.doctorById = action.payload;
      })
      .addCase(getDoctorById.rejected, (state, action) => {
        state.doctorByIdLoading = false;
        state.doctorByIdError = action.error.message;
      });
  },
});

export default doctorSlice.reducer;
